/* eslint-disable no-trailing-spaces */
/* eslint no-console: ["error", { allow: ["warn", "error", "info"] }] */
/* eslint no-invalid-this: 0 */
/* eslint max-len: 0 */

// This utils file should contain all utility functions
// functions can then be called using utils.someFunc() from within scripts.js

import Pikaday from 'pikaday';
import moment from 'moment';

export function initDatePickers() {
	$(document).find('[data-date-picker="true"]').each(function() {
        let $inp = $(this)[0];
        let dob = $(this).data('datePickerDob');
        let full = $(this).data('datePickerFull');
        let options;
        if (dob) {
            options = {
                field: $inp,
                format: 'DD-MM-YYYY',
                yearRange: [1900, moment().format('YYYY')],
				maxDate: moment().toDate(),
                setDefaultDate: false,
            };
        } else {
            if (full) {
                options = {
                    field: $inp,
                    format: 'dddd Do MMMM YYYY',
                    minDate: moment().toDate(),
                    maxDate: moment().endOf('year').add('1', 'years').toDate(),
					defaultDate: moment().toDate(),
                    setDefaultDate: true,
                };
            } else {
                options = {
                    field: $inp,
                    format: 'DD-MM-YYYY',
                    minDate: moment().toDate(),
                    maxDate: moment().endOf('year').add('1', 'years').toDate(),
                    setDefaultDate: false,
                };
            }
        }

        // init
		const pikaday = new Pikaday(options);
		const egiftForm = $inp.closest('.delivery-date-field');
		if (egiftForm) {
			let $icon = $(egiftForm).find('.icon-chevron-down');
			$($icon).on('click', () => {
				pikaday.show();
			});
		}
    });
}



// WEBPACK FOOTER //
// ./date-picker.js